import { render, staticRenderFns } from "./selectOrderType.vue?vue&type=template&id=52c61840"
import script from "./selectOrderType.vue?vue&type=script&lang=js"
export * from "./selectOrderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports